import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx';
import { IonicModule, Platform } from '@ionic/angular';

export interface UserAvatar {
  name?: string;
  full_name?: string;
  avatar?: string;
}

/**
 * Renders the user avatar or just the initials if no picture available.
 * Future: https://angular.io/guide/dynamic-component-loader
 */
@Component({
  selector: 'user-avatar',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
})
export class UserAvatarComponent implements OnInit, OnChanges {
  // avatar string
  public avatar: string;

  // name initial
  public initials: string;

  // current os flag
  public isIOS: boolean;

  // avatar size
  @Input() size = 48;

  // font
  font;

  // user or conversation object
  @Input() user: UserAvatar;

  // show large image flag
  @Input() showLargeImage = false;

  // display user availabilty status
  @Input() isOnline = false;

  constructor(
    private platform: Platform,
    private photoViewer: PhotoViewer,
  ) {
    this.isIOS = this.platform.is('ios');
  }

  ngOnInit() {
    this.font = (8 + this.size * 0.2).toFixed();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.user) {
      this.initializeUser();
    }
  }

  /**
   * check user object is anonymous
   *
   */
  userIsAnonymous(): boolean {
    // anonymous users are returned with a name "a mable member"
    return this.user && this.user.name && this.user.name.toLowerCase() === 'a mable member';
  }

  /**
   * Initialize user avatar
   *
   */
  initializeUser() {
    // check user is exists
    if (this.user && Object.keys(this.user).length) {
      const avatarLink = this.user.avatar || '';
      // some APIs return full_name instead of name so handling both here
      this.user.name = this.user.name || this.user.full_name;
      // If users avatar is default use initials
      if (avatarLink === '' || avatarLink?.match(/default_avatars/)) {
        this.initials = this.initialsFor(this.user.name);
      } else {
        this.avatar = avatarLink;
      }
    }
    // this.avatar = 'https://www.fillmurray.com/200/300';
  }

  /**
   * Get initials from name
   *
   * @param name - name for get initials
   */
  private initialsFor(name: string): string {
    // get the initials
    const initials = name
      .toUpperCase()
      .split(' ')
      .map((w) => w[0]);
    const numToRemove = Math.max(0, initials.length - 2);

    initials.splice(1, numToRemove);

    return initials.join('');
  }

  /**
   * show image as large view
   *
   */
  enlargeImage() {
    if (this.showLargeImage) {
      const options = {
        share: false,
        closeButton: true,
        copyToReference: true,
        headers: '',
        piccasoOptions: {},
      };
      this.photoViewer.show(this.avatar.replace('/small_', '/big_'), this.user.name, options);
    }
  }
}
